import { Component, OnInit, QueryList, ViewChildren, ViewChild, IterableDiffers, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BulkUploadComponent } from '../bulkupload/bulkupload.component';
import { ExceluploadComponent } from '../excelupload/excelupload.component';
import { DocumentService } from 'src/app/Service/document/document.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { IDocumentApprovalModel, IDocumentExcelUploadModel, IDocumentRevHistoryModel, IDocumentMailInputModel, DocumentGridSettings, IDocumentListInputModel, IDocReceiverStatus, IDocumentDynamicSearchModel } from 'src/app/ViewModel/DocumentModel';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { LoaderService } from 'src/app/Service/Loader/loader.service';
import { CommonService } from 'src/app/Service/Common.service';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { FileUploadComponent } from 'src/app/CommonComponents/file-upload/file-upload.component';
import { FileListComponent } from 'src/app/CommonComponents/file-list/file-list.component';
import { EmployeeCartDialogComponent } from '../employee-cart-dialog/employee-cart-dialog.component';

import { CreateMessageComponent } from '../../communication/create-message/create-message.component';
import { RestApiService } from 'src/app/Service/rest-api.service';
import { EncryptDecryptService } from 'src/app/Service/encrypt-decrypt.service';
import { Align } from '@progress/kendo-angular-popup';
import { DocumentMailListComponent } from '../document-mail-list/document-mail-list.component';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { DocumentReviewComponent } from '../document-review/document-review.component';
import { FileService, FileUploadLibrary } from 'src/app/Service/file/file.service';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import * as _ from 'lodash';
import { DocumentRepositoryhistoryDialogComponent } from '../document-repositoryhistory-dialog/document-repositoryhistory-dialog.component';
import { DynamickendoService } from 'src/app/CommonComponents/Dynamic-Kendo-UI/Service/Dynamic-kendo.service';
import { Router } from '@angular/router';
import { SortDescriptor, State } from '@progress/kendo-data-query';
import { Subscription } from 'rxjs/internal/Subscription';
import { Observable } from 'rxjs/internal/Observable';
import { DynamicFormComponent } from 'src/app/CommonComponents/dynamic-form/components/dynamic-form/dynamic-form.component';
import { FormControl, FormGroup } from '@angular/forms';
import { IMsgElementInputModel } from 'src/app/ViewModel/CommunicationModel';
import { FieldConfig } from 'src/app/CommonComponents/dynamic-form/interface/field.interface';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { IProjectElementDetailsOutput, IProjectElementsOutput } from 'src/app/ViewModel/ProjectElementsModel';
import * as moment from 'moment';
import { formatDate, DatePipe } from '@angular/common';

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.css']
})
export class DocumentComponent implements OnInit, OnDestroy {
  @ViewChild("docSetForm") dynamicForm: DynamicFormComponent;
  @ViewChild(DataBindingDirective) dataBinding!: DataBindingDirective;
  foraction!: boolean;
  selectedIndex = 0;
  selectedRootIndex = 4;
  selectedTabIndex = 0;
  inprogress!: boolean;
  approved!: boolean;
  landingall!: boolean;
  rejected!: boolean;
  issued!: boolean;
  memberId: number = 0;
  memberName: string = '';
  projectId!: number;
  groupId: number = 0;
  enableFilter = false;
  enableFullscreen = false;
  pageSize = 15;
  LastViewingRecords = 30;
  LastViewingRecord: string = "30";
  noOfDays = [30, 60, 90, 120, 180, 360, 'All'];
  canEdit: boolean = false;
  canSuperEditApprovedDocuments: boolean = false;
  canSuperEdit: boolean = false;
  canSupersede: boolean = false;
  canUpload: boolean = false;
  canView: boolean = false;
  canDelete: boolean = false;
  hasOrgView: boolean = false;
  hasSuperView: boolean = false;
  isRedirected: boolean = false;
  hasWorkFlowHistory: boolean = false;
  public isSearch: any;
  public showRevHistory!: boolean;
  public canApprove!: boolean;
  public showInProgress!: boolean;
  public isLatest: boolean = true;
  public isPending: boolean = true;
  public gridData: any[] = [];
  public data: any[] = [];
  public dynamicHeader: any[] = [];
  public documentList: any[] = [];
  public searchList: any[] = [];
  public approvedList: any[] = [];
  public forActionList: any[] = [];
  public rejectedList: any[] = [];
  public inProgressList: any[] = [];
  public buttonType = 'MyDocuments';
  public lastscrollLeft!: number;
  public viewTabs: any = [];
  public viewData: any[] = [];
  public shareDocList: any[] = [];
  public revHistory: IDocumentRevHistoryModel | null = null;
  public anchorElementPopup: any;
  private anchorAlignLeft: Align = { horizontal: 'left', vertical: 'bottom' };
  private popupAlignLeft: Align = { horizontal: 'left', vertical: 'top' };
  public popupMargin = { horizontal: -15, vertical: 10 };
  @ViewChildren('docGrid') docGrid: any;
  @ViewChildren('docDynamicGrid') public docDynamicGrid: any;
  @ViewChild('file') file;
  acceptFileTypes: string = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  public searchGridParameters: any;
  public gridDatafrm: any;
  public grid!: any;
  public locked!: any;
  public _Url: string = "";
  public grdSettings!: any[];
  public sort: SortDescriptor[] = [];
  public iterableDiffer: any;
  private uris = {
    // uploadFile: "/RepositoryDocuments/UploadTemplate",
    downloadFile: "/RepositoryDocuments/DownloadTemplate",
  };
  UnsubscribeArray: Subscription[] = [];
  public regConfig: FieldConfig[] = [];
  public numElements: Map<string, string> = new Map<string, string>();
  public projectElements: any[];
  public elementInp: IMsgElementInputModel[] = [];
  public searchForm: FormGroup = new FormGroup({
    ctrlSearchText: new FormControl(),
    ctrlType: new FormControl(),
    ctrlGroup: new FormControl(),
    ctrlRevision: new FormControl()
  });
  public start: string;
  public end: string;
  public searchTypeList: any[];
  freesearch: IDocumentDynamicSearchModel;
  tempdata: any[] = [];
  onlyded: any[] = [];
  public dataglobal: any[] = [];
  public nodata: boolean = true;
  // field: FieldConfig;
  public selectedTypeIndex: number = -1;
  public selectedTypeValue: string;
  public isBulkDownload: boolean = false;

  @ViewChildren('divIcon') divIconHover!: QueryList<any>;
  constructor(private dialog: MatDialog,
    private loaderService: LoaderService,
    private _docService: DocumentService,
    private _notificationService: NotificationService,
    private http: HttpClient,
    private restApiService: RestApiService,
    private commonService: CommonService,
    private encryptDecryptService: EncryptDecryptService,
    private _DynamickendoService: DynamickendoService,
    private router: Router,
    private iterableDiffers: IterableDiffers,
    private _projService: ProjectInfoService,
    public datepipe: DatePipe,
    private _fileService: FileService) {

    this.allData = this.allData.bind(this);
    this.iterableDiffer = iterableDiffers.find([]).create();
  }

  ngOnInit() {
    this._Url = this.router.url;
    if (this.commonService.hasRequestedObject()) {
      setTimeout(() => {
        this.initialPageLoad();
      }, 2000);
    }
    else {
      this.initialPageLoad();
    }
    this.GetGridsettigs();
    this.getDynamicForm();
  }

  public state: State = {
    skip: 0,
    take: 50,
    sort: [],
    filter: {
      logic: "and",
      filters: []
    }
  };

  async initialPageLoad() {
    this.memberId = this.commonService.getLoggedInUserId();
    this.projectId = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.memberName = this.commonService.getLoggedInUserName();
    this.approved = false;
    await this.callMemberRoleandFeature();
    this.refreshGrid();
    this.grid = new DocumentGridSettings(true);
    this.locked = new DocumentGridSettings(false);
  }

  setRedirectObjects() {
    if (this.data.length > 0 && this.commonService.hasRequestedObject()) {/*Mail Redirection*/
      var requestedObject = JSON.parse(this.encryptDecryptService.decrypt(this.commonService.getSessionStorageItem('requestedObject')));
      let inputDocId = requestedObject['inputDocId'];
      let inputRevNo = requestedObject['inputRevNo'];

      if (inputDocId && inputRevNo) {
        this.commonService.checkAndDeleteRequestedObject();
        let _data = this.data.filter(x => x.docId == inputDocId && x.revision == inputRevNo);

        if (_data.length > 0) {
          this.viewDocumentClick(_data[0]);
          this.isRedirected = true;
        }
        else {
          this._notificationService.showToast("You are not authorized to view the document", "Warning");
        }
      }
    }

    if (this.commonService.hasSearchedObject()) {/*Search Redirection*/
      if (this.data.length <= 0) {
        this._notificationService.showToast("You are not authorized to view the document", "Warning");
        return;
      }
      var searchedObject = JSON.parse(this.encryptDecryptService.decrypt(this.commonService.getSessionStorageItem('searchedObject')));
      let inputdocNo = searchedObject['searchDocNo'];
      let inputRevNo = searchedObject['searchRevNo'];

      if (inputdocNo && inputRevNo) {
        this.commonService.checkAndDeleteSearchedObject();
        let _data = this.data.filter(x => x.documentNo == inputdocNo && x.revision == inputRevNo);

        if (_data.length > 0) {
          this.viewDocumentClick(_data[0]);
          this.isRedirected = true;
        }
        else {
          this._notificationService.showToast("You are not authorized to view the document", "Warning");
        }
      }
    }
  }

  getGridData() {
    if (this.selectedTabIndex != 0) {
      this.viewData = [];
      let tab: any = this.viewTabs[this.selectedTabIndex - 1];
      this.viewData.push({
        projectId: this.projectId,
        groupId: this.groupId,
        docId: tab.docId,
        revisionNo: tab.revision
      });
    }
    if (this.searchList.length > 0) {
      this.documentList = this.searchList;
      this.dataBinding.skip = 0;
    }
    else {
      this.approvedList = this.data.filter(doc => doc.trans_type == 'Approved');
      this.forActionList = this.data.filter(doc => doc.trans_type == 'For Action');
      this.rejectedList = this.data.filter(doc => doc.trans_type == 'Rejected');
      this.inProgressList = this.data.filter(doc => doc.trans_type == 'In Progress' && doc.isFileAttached != this.isPending);
      switch (this.selectedRootIndex) {
        case 0:
          this.documentList = this.inProgressList;
          break;
        case 1:
          this.documentList = this.forActionList;
          break;
        case 2:
          this.documentList = this.approvedList;
          break;
        case 3:
          this.documentList = this.rejectedList;
          break;
        default:
          this.documentList = this.data;
          break;
      }
      this.dataBinding.skip = 0;
    }
  }

  /**
   * Status Tab Select based Grid Binding
   * @param event
   *
   */
  public tabClick(event: { tab: { textLabel: string; }; }) {
    if (this.docGrid && this.docGrid._results && this.docGrid._results.length > 0 && this.docGrid._results[0].defaultSelection)
      this.docGrid._results[0].defaultSelection.selectedKeys = [];
    else if (this.docDynamicGrid && this.docDynamicGrid._results && this.docDynamicGrid._results.length > 0 && this.docDynamicGrid._results[0].defaultSelection)
      this.docDynamicGrid._results[0].defaultSelection.selectedKeys = [];
    //Reset the isselected flag as false
    this.documentList.forEach(x => x.isSelected = false);
    this.searchList = [];
    this.canApprove = (event.tab.textLabel === 'For Action');
    this.showInProgress = (event.tab.textLabel === 'In Progress');
    this.getDocumentList1(event.tab.textLabel);
    if (event.tab.textLabel === 'Issued') {
      this.foraction = false;
      this.inprogress = false;
      this.landingall = false;
      this.approved = false;
      this.rejected = false;
      this.issued = true;
    } else if (event.tab.textLabel === 'For Action') {
      this.foraction = true;
      this.inprogress = false;
      this.landingall = false;
      this.approved = false;
      this.rejected = false;
      this.issued = false;
    } else if (event.tab.textLabel === 'In Progress') {
      this.foraction = false;
      this.inprogress = true;
      this.landingall = false;
      this.approved = false;
      this.rejected = false;
      this.issued = false;
    } else if (event.tab.textLabel === 'Approved') {
      this.foraction = false;
      this.inprogress = false;
      this.landingall = false;
      this.approved = true;
      this.rejected = false;
      this.issued = false;
    } else if (event.tab.textLabel === 'All') {
      this.foraction = false;
      this.inprogress = false;
      this.landingall = true;
      this.approved = false;
      this.rejected = false;
      this.issued = false;
    } else if (event.tab.textLabel === 'Rejected') {
      this.foraction = false;
      this.inprogress = false;
      this.landingall = false;
      this.approved = false;
      this.rejected = true;
      this.issued = false;
    }
    this.getGridData();
    this.enableFilter = false;
    this.dataBinding.filter = undefined;
  }

  getDocumentList1(textLabel: string) {
    if (textLabel != 'In Progress') {
      this.documentList = (this.data.filter(doc => doc.trans_type == textLabel && doc.isFileAttached != this.isPending));
    }
    else if (textLabel == 'In Progress') {
      this.documentList = (this.data.filter(doc => doc.trans_type == textLabel));
    }
    else {
      this.documentList = this.data;
    }
  }

  /**
   * Button Type function changes
   * @param val
   */
  public onValChange(val: string) {
    this.searchList = [];
    //Reset the isselected flag as false
    this.documentList.forEach(x => x.isSelected = false);
    this.buttonType = val;
    this.refreshGrid();
    this.enableFilter = false;
    this.dataBinding.filter = undefined;
  }

  /**
   * Data Binding in Grid
   * @param type
   *
   */
  public async refreshGrid() {
    let inputDocId = null;
    let inputdocNo = null;
    let inputRevNo = null;
    if (this.commonService.hasRequestedObject()) {
      var requestedObject = JSON.parse(this.encryptDecryptService.decrypt(this.commonService.getSessionStorageItem('requestedObject')));
      inputDocId = requestedObject['inputDocId'];
      inputRevNo = requestedObject['inputRevNo'];
      this.selectedRootIndex = 4;
    }
    if (this.commonService.hasSearchedObject()) {
      var searchedObject = JSON.parse(this.encryptDecryptService.decrypt(this.commonService.getSessionStorageItem('searchedObject')));
      inputdocNo = searchedObject['searchDocNo'];
      inputRevNo = searchedObject['searchRevNo'];
      this.selectedRootIndex = 4;
    }
    let inputModel: IDocumentListInputModel = {
      projectId: this.projectId,
      groupId: this.groupId,
      memberId: this.memberId,
      transType: this.buttonType,
      createdFromDays: this.LastViewingRecords,
      docId: inputDocId == null ? inputDocId : +inputDocId,
      docNo: inputdocNo,
      revisionNo: inputRevNo
    }
    this.data = await this._docService.getDocumentList(inputModel).toPromise();
    this.dataglobal = this.data;
    this.data.forEach(x => x.isSelected = false);

    if (this.isLatest) {
      this.data = this.data.filter(doc => doc.isLatest == true);
    }

    if (this.data && this.data[0].dynamicHeader) {
      this.dynamicHeader = this.data[0].dynamicHeader.split('~');
      this.data.forEach(x => {
        x.dynamicValue = x.dynamicValue ? x.dynamicValue.split('~') : null;
        this.dynamicHeader.forEach((value, index) => {
          if (x.dynamicValue)
            x['dynamicValue' + index] = x.dynamicValue[index];
        });
      });
    }

    this.getGridData();
    this.setRedirectObjects();
  }


  public downloadTemplate = async () => {
    this.loaderService.isLoading.next(true);
    let _apiURL = environment.uriHost + this.uris.downloadFile;
    let fileData = { projectId: this.projectId, groupId: this.groupId, memberId: this.memberId }

    const headers = {
      'X-Requested-With': 'XMLHttpRequest',
      'Authorization': 'Bearer ' + this.commonService.getJWT(),
      'loginAuditNumber': this.encryptDecryptService.decrypt(this.commonService.getLoginAuditNumber())
    }

    let download$: Observable<Blob> = this.http.post(_apiURL, fileData, { 'headers': headers, responseType: 'blob' });
    download$.subscribe(
      (data: any) => {
        this.loaderService.isLoading.next(false);
        const downloadLink = document.createElement("a");
        downloadLink.setAttribute('style', 'display:none;');
        downloadLink.href = window.URL.createObjectURL(data);
        downloadLink.download = 'Edms_excel_upload.xlsx';
        downloadLink.target = '_blank';
        downloadLink.click();
        document.body.removeChild(downloadLink);
      },
      (err: any) => {
        this.loaderService.isLoading.next(false);
        this._notificationService.showToast("Error in downloading Template, try after some time", "Warning");
      });
  }

  handleClick() {
    this.file.nativeElement.click();
  }

  addAttachment(event: any) {
    this.loaderService.isLoading.next(true);
    if (event.target.files[0].type != this.acceptFileTypes) {
      this.loaderService.isLoading.next(false);
      this._notificationService.showPopup("File type is incorrect(*.xlsx file type expected)", "Warning");
      this.file.nativeElement.value = '';
      return;
    }
    const formData: FormData = new FormData();
    formData.append('DocumentExcelTemplate', event.target.files[0], event.target.files[0].name);
    formData.append('ProjectId', this.projectId.toString());
    formData.append('GroupId', this.groupId.toString());
    formData.append('MemberId', this.memberId.toString());
    let _UploadDocumentExcelTemplate = this._docService.UploadDocumentExcelTemplate(formData).subscribe((res: IDocumentExcelUploadModel[]) => {
      this.loaderService.isLoading.next(false);
      if (res.length > 0) {
        let dialogRef = this.dialog.open(ExceluploadComponent, {
          panelClass: 'mat-dialog-primary',
          data: res,
        });
        let _excelUploadComponent = dialogRef.afterClosed().subscribe((res: any) => {
          this.ngOnInit();
        });
        this.UnsubscribeArray.push(_excelUploadComponent);
      }
      else {
        this._notificationService.showPopup("No Records Found / Invalid File", "Warning");
      }
      this.file.nativeElement.value = '';
    }, err => {
      this.loaderService.isLoading.next(false);
      this.file.nativeElement.value = '';
      this._notificationService.showToast("Error in upload Template", "Warning");
    })
    this.UnsubscribeArray.push(_UploadDocumentExcelTemplate);
  }
  private processFile = async (inputFile: Blob) => {
    const temporaryFileReader = new FileReader();
    return new Promise((resolve, reject) => {
      temporaryFileReader.readAsArrayBuffer(inputFile);
      temporaryFileReader.onload = (event: any) => {
        resolve(event.target['readyState'] == FileReader.DONE ? (new Uint8Array(event.target['result'])) : null);
      };
    });
  };

  /**Lastviewrecords change */
  public lastviewingrecordsmethod(event: any) {
    if (event == "All") {
      this.LastViewingRecords = 0;
      this.refreshGrid();
      this.LastViewingRecord = "All";
    }
    else {
      this.LastViewingRecords = event;
      this.LastViewingRecord = event;
      this.refreshGrid();
    }
    this.enableFilter = false;
    this.dataBinding.filter = undefined;
  }

  public advanceSearch() {
    this.searchList = [];
    switch (this.selectedRootIndex) {
      case 0:
        this.documentList = this.inProgressList;
        break;
      case 1:
        this.documentList = this.forActionList;
        break;
      case 2:
        this.documentList = this.approvedList;
        break;
      case 3:
        this.documentList = this.rejectedList;
        break;
      default:
        this.documentList = this.data;
        break;
    }
    this.isSearch = !this.isSearch;
    this.showRevHistory = false;
    this.enableFilter = false;
    this.dataBinding.filter = undefined;
    this.state.filter = {
      logic: "and",
      filters: []
    };
  }

  /**
   * Closed Search
   * @param event
   */
  closeAdvSearch(event: any[]) {
    this.searchList = event;
    // this.isSearch = false;
    if (this.searchList.length == 0) {
      this._notificationService.showToast("Search returned no results", "Warning");
    }
    else {
      this.documentList = this.searchList;
      this.dataBinding.skip = 0;
    }
    this.enableFilter = false;
    this.dataBinding.filter = undefined;
  }

  public openRevHistory(event: { target: any; }, docId: number) {
    this.showRevHistory = !this.showRevHistory;
    if (this.showRevHistory) {
      this.revHistory = {
        docId: docId,
        groupId: this.groupId,
        memberId: this.memberId,
        transType: this.buttonType
      };
    }
    else {
      this.revHistory = null;
    }
    this.anchorElementPopup = event.target;
  }

  public closeRevHistory() {
    this.showRevHistory = false;
    this.anchorElementPopup = undefined;
  }

  /**
   * Toggle filter
   */
  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  /**
     * Full screen
     */
  toggleFullscreen() {
    this.enableFullscreen = !this.enableFullscreen;
  }

  /**
   * Grid Mouseover function
   * @param event
   */
  onHover(event: Event): void {
    if ((event.target as HTMLElement).closest('div.k-grid-content')) {
      let _x: any = event.target as HTMLElement;
      if (_x) {
        const newscrollLeft = _x.closest('div.k-grid-content').scrollLeft;
        if (this.lastscrollLeft !== newscrollLeft) {
          for (let i = 0; i < this.divIconHover.length; i++) {
            this.divIconHover['_results'][i]['nativeElement']['style'].right = (0 - newscrollLeft) + 'px';
          }
          this.lastscrollLeft = newscrollLeft;
        }
      }
    }
  }

  /**
   * File attachment for each row documents in grid
   * @param data
   */
  attachmentClick(data: any) {
    const dialog = this.dialog.open(FileUploadComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '50%',
      data: { projectId: this.projectId, docId: data.docId, revisionNo: data.revision, moduleName: 'EDMS', libraryName: FileUploadLibrary.Documents, createdBy: this.memberId, documents: [{ value: data.docId, text: data.documentNo, revisionNo: data.revision, task_SNo: 0 }], isEditable: false },
    });
    dialog.afterClosed().subscribe((res: any) => {
      if (data.authorisedBy == this.memberId) {
        let inputModel: IDocumentApprovalModel = {
          DocId: data.docId,
          RevisionNo: data.revision,
          RevisedOn: data.revisedOn,
          IsApproved: true,
          ApprovedBy: this.memberId
        };
        let docApprovalattachment = this._docService.DocumentApproval(inputModel).subscribe((res: StandardOutputModel) => {
          // if (res.successCode == 200) {
          //   this._notificationService.showToast(res.successMessage, "Success");
          // }
          // else if (res.successCode == 500) {
          //   this._notificationService.showToast(res.successMessage, "Error");
          // }
        });
        this.UnsubscribeArray.push(docApprovalattachment);
      }
      this.refreshGrid();
    });
  }

  viewAttachmentClick(data: any) {
    const dialog = this.dialog.open(FileListComponent, {
      panelClass: ['mat-dialog-secondary', 'w80'],
      data: { projectId: this.projectId, docId: data.docId, revisionNo: data.revision, libraryName: FileUploadLibrary.Documents, createdBy: this.memberId, isDeleteEnable: this.canEdit, documentNo: data.documentNo },
    });
    dialog.afterClosed().subscribe((res: any) => {
      this.refreshGrid();
    })
  }

  viewMessageList(category: number, data: any) {
    let inputModel: IDocumentMailInputModel = {
      DocId: data.docId,
      DocumentNo: data.documentNo,
      Category: category,
      ProjectId: this.projectId,
      GroupId: this.groupId,
      MemberId: this.memberId,
      TransType: this.buttonType,
      revisionNo: null
    };
    this.dialog.open(DocumentMailListComponent, {
      panelClass: ['mat-dialog-secondary', 'w80'],
      data: inputModel
    });
  }

  viewDocumentClick(data: any) {
    let index = this.viewTabs.indexOf(data);
    if (index == -1) {
      if (!this.canView) {
        this._notificationService.showPopup("You do not have View access. Kindly contact Admin", 'Information');
        return;
      }
      this.viewTabs.push(data);
      this.selectedTabIndex = 1;
    }
  }

  viewDocumentsClick() {
    this.documentList.forEach((element: any) => {
      if (element.isSelected) {
        let index = this.viewTabs.indexOf(element);
        if (index == -1) {
          this.viewTabs.push(element);
          this.selectedTabIndex = 1;
        }
      }
    });
    if (this.viewTabs.length == 0) {
      this._notificationService.showToast("No document is selected", "Warning");
    }
  }

  /**
   * Multiple select of listed documents for approval or reject
   * @param event
   *
   */
  onSelectionChange(event: any): void {
    if (event['selectedRows'].length > 0) {
      event['selectedRows'].forEach((element: { dataItem: { isSelected: boolean; }; }) => {
        element.dataItem.isSelected = true;
      });
    }
    if (event['deselectedRows'].length > 0) {
      event['deselectedRows'].forEach((element: { dataItem: { isSelected: boolean; }; }) => {
        element.dataItem.isSelected = false;
      });
    }
  }

  public approveAll(isApproved: any) {
    this.documentList.forEach(element => {
      if (element.isSelected) {
        let inputModel: IDocumentApprovalModel = {
          DocId: element.docId,
          RevisionNo: element.revision,
          RevisedOn: this.datepipe.transform(
            element.revisedOn,
            'YYYY-MM-dd HH:MM:SS'
          ),
          IsApproved: isApproved,
          ApprovedBy: this.memberId
        };
        let docApprovalAll = this._docService.DocumentApproval(inputModel).subscribe((res: StandardOutputModel) => {
          if (res.successCode == 200 && res.successMessage == "Document Approved Successfully...") {
            this._notificationService.showToast(res.successMessage, "Success");
          }
          else if (res.successCode == 200 && res.successMessage == "Document Rejected Successfully...") {
            this._notificationService.showToast(res.successMessage, "Warning");
          }
          else if (res.successCode == 500) {
            this._notificationService.showToast(res.successMessage, "Error");
          }
          this.refreshGrid();
        });
        this.UnsubscribeArray.push(docApprovalAll);
      }
    });
  }

  /**
   * Grid on hover approval function
   * @param data
   *
   */
  approvalClick(data: any) {
    let inputModel: IDocumentApprovalModel = {
      DocId: data.docId,
      RevisionNo: data.revision,
      RevisedOn: this.datepipe.transform(
        data.revisedOn,
        'YYYY-MM-dd HH:MM:SS'
      ),
      IsApproved: true,
      ApprovedBy: this.memberId
    };
    let docApproveClick = this._docService.DocumentApproval(inputModel).subscribe((res: StandardOutputModel) => {
      if (res.successCode == 200) {
        this._notificationService.showToast(res.successMessage, "Success");
      }
      else if (res.successCode == 500) {
        this._notificationService.showToast(res.successMessage, "Error");
      }
    });
    this.UnsubscribeArray.push(docApproveClick);
    this.refreshGrid();
  }

  /**
   * Grid on hover  reject function
   * @param data
   *
   */
  rejectedClick(data: any) {
    let inputModel: IDocumentApprovalModel = {
      DocId: data.docId,
      RevisionNo: data.revision,
      RevisedOn: data.revisedOn,
      IsApproved: false,
      ApprovedBy: this.memberId
    };
    let docrejectedClick = this._docService.DocumentApproval(inputModel).subscribe((res: StandardOutputModel) => {
      if (res.successCode == 200) {
        this._notificationService.showToast(res.successMessage, "Warning");
      }
      else if (res.successCode == 500) {
        this._notificationService.showToast(res.successMessage, "Error");
      }
    });
    this.UnsubscribeArray.push(docrejectedClick);
    this.refreshGrid();
  }

  public createdocument() {
    let dialogRef = this.dialog.open(BulkUploadComponent, {
      panelClass: 'mat-dialog-primary',
      autoFocus: false,
      disableClose: true,
      data: { docId: 0, revisionNo: '', isSupersede: false },
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      this.refreshGrid();
    });
  }

  public editDocument(doc: any, isSupersede: boolean) {
    let dialogRef = this.dialog.open(BulkUploadComponent, {
      panelClass: 'mat-dialog-primary',
      data: { docId: doc.docId, revisionNo: doc.revision, isSupersede: isSupersede,docGroupId: doc.groupId },
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      this.refreshGrid();
    });
  }

  public deleteDocument(doc: any) {
    this._notificationService.showPopup('Are you sure you want to delete', 'Confirm').then(msg => {
      if (msg == 'yes') {
        let reaData = {
          "docId": doc.docId,
          "revisionNo": doc.revision,
          "userId": this.commonService.getLoggedInUserId(),
        };
        let deleteDoc = this._docService.DeleteDoc(reaData).subscribe((res: any) => {
          if (res.successCode == 200) {
            this.refreshGrid();
            this._notificationService.showToast(res.successMessage, "Success");
          }
          else if (res.successCode == 500) {
            this._notificationService.showToast(res.successMessage, "Error");
          }
        });
        this.UnsubscribeArray.push(deleteDoc);
      }
    });
  }

  public viewTabClick(event: { tab: { textLabel: { docId: any; revision: any; groupId: any; }; }; }) {
    let docId = event.tab.textLabel.docId;
    let document = this.documentList.find(x => x.docId == docId);
    this.viewData = [];
    if (document && this.selectedTabIndex != 0) {
      this.viewData.push({
        projectId: this.projectId,
        groupId: event.tab.textLabel.groupId,
        docId: event.tab.textLabel.docId,
        revisionNo: event.tab.textLabel.revision,
        canShare: document.trans_type == 'Approved',
        trans_type: document.trans_type
      });
    }
  }

  public closeViewTab(tab: { docId: any; }) {
    this.viewTabs.forEach(async (value: { docId: any; revision: any; }, index: any) => {
      if (value.docId == tab.docId) {
        let delindex = index;
        this.viewTabs.splice(index, 1);
        let input: IDocReceiverStatus = {
          doc_Id: value.docId,
          member_Id: this.memberId,
          is_Read: 'Y',
          read_On: new Date(),
          revisionNo: value.revision
        };
        let setreposhistory = await this._docService.setRepoHistoryStatus(input).subscribe((res: any) => {
        });
        this.UnsubscribeArray.push(setreposhistory);
        this.selectedTabIndex = delindex + 1;
        this.refreshGrid();
      }
    });
  }

  employeecart() {
    if (this.shareDocList.length > 0) {
      const dialogRef = this.dialog.open(EmployeeCartDialogComponent, {
        panelClass: ['mat-dialog-secondary', 'w80'],
        data: { projectId: this.projectId, groupId: this.groupId, docList: this.shareDocList, userId: this.memberId }
      });
    }
    else {
      this._notificationService.showToast("Please Select Atleast One Document", "Warning");
    }
  }

  shareDocumentList() {
    this.shareDocList = [];
    let selectedDocList = this.documentList.filter(x => x.isSelected);
    selectedDocList.filter(x => x.trans_type == 'Approved').forEach(element => {
      let index = this.shareDocList.indexOf(element);
      if (index == -1) {
        this.shareDocList.push({ docId: element.docId, revision: element.revision });
      }
    });
    if (selectedDocList.length == this.shareDocList.length) {
      this.employeecart();
    }
    else {
      this._notificationService.showToast("Only Approved Documents can be shared", "Warning");
    }
  }

  shareDocument(dataItem: any) {
    this.shareDocList = [];
    if (dataItem.trans_type == 'Approved') {
      let index = this.shareDocList.indexOf(dataItem);
      if (index == -1) {
        this.shareDocList.push({ docId: dataItem.docId, revision: dataItem.revision });
      }
      this.employeecart();
    }
    else {
      this._notificationService.showToast("Document has not been approved", "Warning");
    }
  }
  ViewDocReview(val?: any) {
    let popup_style;
    let width;
    let type;
    if (!val) {
      popup_style = 'mat-dialog-secondary';
      width = '90%';
      type = '';
    } else {
      popup_style = 'mat-dialog-primary';
      type = 'all';
    }
    let dialogRef = this.dialog.open(DocumentReviewComponent, {
      panelClass: popup_style,
      width: width,
      data: { inputType: type }
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      if (!!data) {
      }
    });

  }
  createMessageClick(dataItem: any) {
    let selectedDocuments = [];
    if (dataItem != undefined && dataItem != null) {
      let item = {
        docId: dataItem.docId,
        documentNo: dataItem.documentNo,
        title: dataItem.title,
        revision: dataItem.revision,
        authorisedByName: dataItem.authorisedByName,
        createdByName: dataItem.createdBy
      }
      selectedDocuments.push(item);
    }
    else {
      selectedDocuments = this.documentList.filter(x => x.isSelected).map(x => {
        return {
          docId: x.docId,
          documentNo: x.documentNo,
          title: x.title,
          revision: x.revision,
          authorisedByName: x.authorisedByName,
          createdByName: x.createdBy
        }
      });
    }
    if (selectedDocuments.length > 0) {
      const dialogRef = this.dialog.open(CreateMessageComponent, {
        panelClass: 'mat-dialog-primary',
        data: { inputType: 'createDocumentMail', selectedList: selectedDocuments }
      });
    }
    else {
      this._notificationService.showToast("Please Select Atleast One Document", "Warning");
    }
  }

  onGridSettingReload() {
    this.getGridSettings();
  }
  getGridSettings() {
    this.searchGridParameters = {
      headers: {
        AccessFlag: 'N',
        LoginAuditNo: this.encryptDecryptService.decrypt(this.commonService.getLoginAuditNumber())
      },
      requestedparamsforgetdatafromDB: {
        intUID: 1692687,
        intCompanyCode: 1,
        intDTCode: 1,
        chrDOPTCode: 'V',
        strGridID: 'documentLandingGrid'
      }
    };
    this.gridDatafrm = {
      "columnName": [
        'Document No.',
        'Title',
        'Revision', ,
        'Revised On',
        'Document Date',
        'Created By',
        'Approved By',
        'Status',
        'Reference'
      ],
      "fieldName": [
        'documentNo',
        'title',
        'revision',
        'revisedOn',
        'docDate',
        'createdBy',
        'authorisedByName',
        'status',
        'reference'
      ]
    };
    let getGridSetting = this.commonService.GetGridSettings(this.searchGridParameters)
      .subscribe(
        (response: any) => {
          this.grid = new DocumentGridSettings(true);
          response.table.forEach((setting: any) => {
            this.grid[setting.mudvD_Field_Name] = (setting.mudvD_Is_ColumnVisible === 'Y') ? true : false;
            this.locked[setting.mudvD_Field_Name] = (setting.mudvD_Is_ColumnFreezed === 'Y') ? true : false;
          });
        }
      );
    this.UnsubscribeArray.push(getGridSetting);
  }

  async callMemberRoleandFeature() {
    let memberrolefeature = await this.commonService.getProjectMemberFeatures(this.projectId, this.memberId, this.groupId).subscribe((result1: any[]) => {
      this.canSupersede = result1.some(data => data.feature_Desc == 'Supersede');
      this.canSuperEdit = result1.some(data => data.feature_Desc == 'Super Edit');
      this.canSuperEditApprovedDocuments = result1.some(data => data.feature_Desc == 'Super Edit Approved Doc');
      this.canEdit = result1.some(data => data.feature_Desc == 'Edit');
      this.hasOrgView = result1.some(data => data.feature_Desc == 'Doc Org View');
      this.hasSuperView = result1.some(data => data.feature_Desc == 'Doc Super View');
      this.canUpload = result1.some(data => data.feature_Desc == 'Upload');
      this.canView = result1.some(data => data.feature_Desc == 'View');
      this.canDelete = result1.some(data => data.feature_Desc == 'Delete');
      this.hasWorkFlowHistory = result1.some(data => data.feature_Desc == 'Workflow History');
      this.isBulkDownload = result1.some(data => data.feature_Desc == 'Bulk Download')
    });
    this.UnsubscribeArray.push(memberrolefeature);
  }


  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.documentList
    };
    return result;
  }

  public openRepositoryHistory(dataItem: any) {
    if (dataItem.trans_type == 'Approved') {
      let dialogRef = this.dialog.open(DocumentRepositoryhistoryDialogComponent, {
        panelClass: 'mat-dialog-primary',
        height: '50',
        maxWidth: '60vw',
        autoFocus: false,
        data: { docId: dataItem.docId, revision: dataItem.revision, documentNo: dataItem.documentNo, }
      });
      dialogRef.afterClosed().subscribe((data: any) => {
      });
    }
    else {
      this._notificationService.showToast("Document has not been approved", "Warning");
    }
  }

  gridSettings() {
    this._DynamickendoService.gridSettings(this.docGrid, this._Url);
  }
  DynamicgridSettings() {
    this._DynamickendoService.gridSettings(this.docDynamicGrid, this._Url);
  }

  GetGridsettigs() {
    let getGridsettings = this._DynamickendoService.GetGridSettings(this._Url).subscribe((res: any) => {
      this.grdSettings = res;
      if (this.grdSettings && this.grdSettings.length > 0 && this.grdSettings[0].sort)
        this.sort = JSON.parse(this.grdSettings[0].sort);
    });
    this.UnsubscribeArray.push(getGridsettings);
  }

  public HelpUrlClick() {
    let x = JSON.parse(this.commonService.getSessionStorageItem("Menu"))
    let url = x.filter((y: { menuDesc: string; }) => y.menuDesc == "Repository Documents")[0].helpUrl
    if (url) {
      window.open(url);
      if (url) { window.open(url); }
    }
  }
  getDynamicForm() {
    this.searchTypeList = [];
    this.searchTypeList.push(
      { value: 0, description: 'Document Number' },
      { value: 1, description: 'Document Title' },
      { value: 2, description: 'Attachments' },
      { value: 3, description: 'Created By' },
      { value: 4, description: 'Approved By' },
      { value: 5, description: 'Status' },
      { value: 6, description: 'Reference' },
      { value: 7, description: 'Comments' }
    );
    let GetprojectElements = this._projService.getProjectElements({ projectId: this.projectId, groupId: this.groupId, moduleId: 1, IsQueryForStaticElement: false }).subscribe(
      (res: IProjectElementsOutput[]) => {
        this.projectElements = res;
        this.projectElements.forEach(element => {
          if (element.elementDescription != 'Project Code') {
            this.searchTypeList.push({ value: element.elementId, description: element.elementDescription });
          }
        });
        this.regConfig = res.map(x => {
          let field: FieldConfig;
          let childDEId = null;
          let childDEDescription = "";
          let data = res.filter(item => item.dependentElementId == x.elementId);
          if (data.length > 0) {
            childDEId = data[0].elementId;
            childDEDescription = data[0].elementDescription;
          }
          field = {
            de_id: x.elementId,
            module_id: 1,
            dependent_de_id: x.dependentElementId,
            dependent_de_Description: x.dependentElementDescription,
            child_de_id: childDEId,
            child_de_Description: childDEDescription,
            name: x.elementDescription,
            deDescription: x.elementDescription,
            type: 'select'
          }
          return field;
        });
        this.dynamicForm.fields = this.regConfig;
        this.dynamicForm.createControl();
      });
    this.UnsubscribeArray.push(GetprojectElements);
  }
  getStartDateValue(selectedText) {
    this.start = selectedText;
  }
  getEndDateValue(selectedText) {
    this.end = selectedText;
  }
  search() {
    this.enableFilter = false;
    this.dataBinding.filter = undefined;

    this.freesearch = null;
    let resForm: FormGroup = this.dynamicForm.value;
    this.elementInp = this.projectElements.map(x => {
      let selectedValue: IProjectElementDetailsOutput = resForm.get(x.elementDescription).value;
      if (selectedValue == null) {
        return null;
      }
      else {
        let result: IProjectElementDetailsOutput = {
          deId: x.elementId,
          dedId: selectedValue.dedId,
          deDescription: x.elementDescription,
          dedDescription: selectedValue.dedDescription,
          dedShortDescription: selectedValue.dedShortDescription,
          sortBy: +selectedValue.sortBy
        }
        return result;
      }
    });
    let searchText = this.searchForm.controls['ctrlSearchText'].value;
    let type = this.searchForm.controls['ctrlType'].value;
    let revision = this.searchForm.controls['ctrlRevision'].value;
    let start = new Date(this.start);
    let end = new Date(this.end);
    let diff = Math.abs(start.getTime() - end.getTime());
    let diffDays = Math.ceil(diff / (1000 * 3600 * 24));
    if (!!searchText && searchText != '' && !!type) {
      let inputModel: IDocumentDynamicSearchModel = {
        projectId: this.projectId,
        memberId: this.memberId,
        docNo: type == 'Document Number' ? searchText : null,
        docTitle: type == 'Document Title' ? searchText : null,
        groupId: this.groupId,
        revisionNo: revision,
        docStatus: type,
        createdType: (moment(this.start)).format('DD/MM/YYYY'),
        createdPeriod: diffDays,
        searchText: searchText
      };
      this.freesearch = inputModel;
    }
    this.searchdynamic();
  }
  async searchdynamic() {
    this.approved = false;
    this.tempdata = [];
    this.onlyded = [];
    this.tempdata = this.dataglobal;
    let fromDate!: Date;
    let toDate!: Date;
    if (this.start && this.end) {
      let startDate = (moment(this.start)).format('DD/MM/YYYY');
      let endDate = (moment(this.end)).format('DD/MM/YYYY');
      let d1 = startDate.split("/");
      let d2 = endDate.split("/");
      let from = new Date(parseInt(d1[2]), parseInt(d1[1]) - 1, parseInt(d1[0]));  // -1 because months are from 0 to 11
      let to = new Date(parseInt(d2[2]), parseInt(d2[1]) - 1, parseInt(d2[0]));
      fromDate = from;
      toDate = to;
      this.tempdata = this.tempdata.filter(x => {
        let c = x.revisedOn.split(".");
        let check = new Date(c[0], parseInt(c[1]) - 1, c[2]);
        if (check >= from && check <= to) {
          return true;
        }
        else {
          return false;
        }
      });
    }
    if (this.elementInp.length > 0) {
      this.elementInp.forEach(x => {
        if (x != null)
          this.onlyded.push(x.dedShortDescription + ' - ' + x.dedDescription);
        else
          this.onlyded.push(null);
      });
    }
    //let dynamiclength = this.tempdata[0].dynamicValue.length;
    let dynamiclength = this.dynamicHeader.length;
    let inputModel!: IDocumentListInputModel
    if (this.freesearch) {
      if (this.freesearch.docStatus == "Document Number") {
        this.tempdata = this.tempdata.filter(x => x.documentNo.toUpperCase().trim().includes(this.freesearch.searchText.toUpperCase().trim()));
        if (this.tempdata && this.tempdata.length <= 0) {
          inputModel = {
            projectId: this.projectId,
            groupId: this.groupId,
            memberId: this.memberId,
            transType: this.buttonType,
            createdFromDays: 0,
            docId: null,
            docNo: this.freesearch.searchText.trim(),
            revisionNo: null
          }
        }
      }
      if (this.freesearch.docStatus == "Document Title") {
        //this.tempdata = this.tempdata.filter(x => x.title.toUpperCase().trim().includes(this.freesearch.searchText.toUpperCase().trim()));
        // if(this.tempdata && this.tempdata.length<=0)
        // {
        //   inputModel = {

        //   }
        // }
        inputModel = {
          projectId: this.projectId,
          groupId: this.groupId,
          memberId: this.memberId,
          transType: this.buttonType,
          docTitle: this.freesearch.searchText.trim(),
          fromDate: fromDate ? fromDate : null,
          toDate: toDate ? toDate : null
        }
      }

      if (this.freesearch.docStatus == "Attachments") {
        this.tempdata = this.tempdata.filter(x =>
          x.fileName ?
            x.fileName.toUpperCase().trim().includes(this.freesearch.searchText.toUpperCase().trim()) : false);
      }
      if (this.freesearch.docStatus == 'Created By') {
        this.tempdata = this.tempdata.filter(x => x.createdBy.toUpperCase().trim().includes(this.freesearch.searchText.toUpperCase().trim()));
      }
      if (this.freesearch.docStatus == 'Approved By') {
        this.tempdata = this.tempdata.filter(x => x.authorisedByName.toUpperCase().trim().includes(this.freesearch.searchText.toUpperCase().trim()));
      }
      if (this.freesearch.docStatus == 'Status') {
        this.tempdata = this.tempdata.filter(x => x.trans_type.toUpperCase().trim().includes(this.freesearch.searchText.toUpperCase().trim()));
      }
      if (this.freesearch.docStatus == 'Reference') {
        // this.tempdata = this.tempdata.filter(x => {
        //   if (x.reference)
        //     return x.reference.toUpperCase().trim().includes(this.freesearch.searchText.toUpperCase().trim());
        // });
        inputModel = {
          projectId: this.projectId,
          groupId: this.groupId,
          memberId: this.memberId,
          transType: this.buttonType,
          reference: this.freesearch.searchText.trim(),
          fromDate: fromDate ? fromDate : null,
          toDate: toDate ? toDate : null
        }
      }
      if (this.freesearch.docStatus == 'Comments') {
        this.tempdata = this.tempdata.filter(x => {
          if (x.comments)
            return x.comments.toUpperCase().trim().includes(this.freesearch.searchText.toUpperCase().trim());
        });
      }
    }
    if (inputModel) {
      await this._docService.getDocumentList(inputModel).toPromise().then((res: any) => {
        this.tempdata = res;
        this.checkFilterDocuments(dynamiclength);
      })
    }
    else {
      this.checkFilterDocuments(dynamiclength);
    }
    this.refreshGridsearch();
    this.grid = new DocumentGridSettings(true);
    this.locked = new DocumentGridSettings(false);
    this.getGridData();
    this.GetGridsettigs();
  }
  checkFilterDocuments(dynamiclength) {
    if (this.dynamicHeader) {
      for (let i = 0; i < dynamiclength; i++) {
        if (this.onlyded[i] != null && this.onlyded[i] != "") {
          this.tempdata = this.tempdata.filter(x => x.dynamicValue && x.dynamicValue.length > 0 ? x.dynamicValue.split('~')[i] == this.onlyded[i] : false);
        }
      }
    }
    if (this.tempdata.length > 0) {
      this.data = this.tempdata;
      this.searchList = [];
      this.documentList = [];
    }
    else {
      this._notificationService.showToast("No Records Found", "Warning");
      this.data = [];
      this.searchList = [];
      this.documentList = [];
    }
  }
  public async refreshGridsearch() {
    let inputDocId = null;
    let inputdocNo = null;
    let inputRevNo = null;
    if (this.commonService.hasRequestedObject()) {
      var requestedObject = JSON.parse(this.encryptDecryptService.decrypt(this.commonService.getSessionStorageItem('requestedObject')));
      inputDocId = requestedObject['inputDocId'];
      inputRevNo = requestedObject['inputRevNo'];
      this.selectedRootIndex = 4;
    }
    if (this.commonService.hasSearchedObject()) {
      var searchedObject = JSON.parse(this.encryptDecryptService.decrypt(this.commonService.getSessionStorageItem('searchedObject')));
      inputdocNo = searchedObject['searchDocNo'];
      inputRevNo = searchedObject['searchRevNo'];
      this.selectedRootIndex = 4;
    }

    this.data.forEach(x => x.isSelected = false);
    if (this.isLatest) {
      this.data = this.data.filter(doc => doc.isLatest == true);
    }
    if (this.data && this.data[0].dynamicHeader) {
      this.dynamicHeader = this.data[0].dynamicHeader.split('~');
      this.data.forEach(x => {
        x.dynamicValue = x.dynamicValue.split('~');
        this.dynamicHeader.forEach((value, index) => {
          x['dynamicValue' + index] = x.dynamicValue[index];
        });
      });
    }
    this.getGridData();
    this.setRedirectObjects();
  }

  downloadAll_OnClick() {
    let selectedDocList = this.documentList.filter(x => x.isSelected);
    if (selectedDocList.length > 0) {
      let fileToBeDownloadedList: any[] = [];
      selectedDocList.forEach(x => {
        if (x.isFileAttached) {
          fileToBeDownloadedList.push(x);
        }
      })
      if (fileToBeDownloadedList.length > 0) {
        let fileInput_DocumentsArray: any[] = [];
        fileToBeDownloadedList.forEach((x, index) => {
          let fileInput_Documents = {
            projectId: this.commonService.getProjectId(),
            docId: x.docId,
            revisionNo: x.revision
          }
          fileInput_DocumentsArray.push({ libraryNumber: FileUploadLibrary.Documents, value: JSON.stringify(fileInput_Documents) });
        })
        this._fileService.DownloadAllFiles(fileInput_DocumentsArray).subscribe((data: any) => {
          const downloadLink = document.createElement("a");
          downloadLink.href = window.URL.createObjectURL(data);
          downloadLink.download = this.commonService.getCurrentProjectDetails().projectCode + "- " + formatDate(new Date(), 'dd-MMM-yyyy', 'en-US') + ".zip";
          downloadLink.click();
          document.body.removeChild(downloadLink);
        }, error => {
          this._notificationService.showToast("Error in downloading attachment, try after some time", "Warning");
        });
      }
      else {
        this._notificationService.showToast("No Attachment is available for the selected document", "Warning");
      }
    }
    else {
      this._notificationService.showToast("Please Select Documents", "Warning");
    }

  }
  ngOnDestroy(): void {
    this.UnsubscribeArray.forEach(x => x.unsubscribe());
  }
}